module.exports = __webpack_public_path__ + "static/media/specialized.5b07aaf6.png";